import React, { useRef, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { patchRevokeSuperAdmin, postCreateSuperAdmin } from '../../../../api/usersApi';
import { ContainedButton, OutlinedButton } from '../../Buttons';
import styles from './SetSuperAdminModal.module.scss';
import { User } from '../../OrganizationCard';
import Modal from '../../Modal';
import { useHotkeys } from 'react-hotkeys-hook';
import { displayRole } from '../../../../helpers';
import { USER } from '../../../../enums';

type TDeleteUserModalProps = {
  isOpen: boolean;
  switchModal: () => void;
  user: USER;
  fetchData: () => void;
};

const SetSuperAdminModal: React.FC<TDeleteUserModalProps> = ({ isOpen, switchModal, user, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const notification = useSnackbar();
  const submitButtonRef = useRef<HTMLSpanElement>(null);
  const onClose = () => {
    switchModal();
    setLoading(false);
  };

  const submit = async () => {
    try {
      setLoading(true);
      await postCreateSuperAdmin(user.email, [], user.username ? user.username : 'User');
      // const res = await postCreateSuperAdmin(user.email, );
      await fetchData();
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  useHotkeys(
    'Enter',
    () => {
      if (isOpen && !loading) {
        submit();
      }
    },
    [isOpen, loading],
  );

  useHotkeys('Enter', () => {
    if (isOpen && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={isOpen} onClose={onClose} loading={loading}>
      <div className={styles.modalBody} onSubmit={submit}>
        <div className={styles.modalTitle}>Are you sure you want set {user.email} as Super Admin?</div>
        <div className={styles.form}>
          <div className={styles.selectedUser}>
            <div>Email: {user.email}</div>
            <div>Username: {user?.username ? user.username : 'no username'}</div>
            <div>Role: {user.role.title.replace('Organization', 'Organisation')}</div>
          </div>

          {user?.organization_users && user?.organization_users?.length > 0 && (
            <ul className={styles.selectedUser}>
              <span className={styles.listHeader}>List of organisations:</span>
              {user.organization_users?.map((u) => (
                <li key={u.id} className={styles.orgObj}>
                  <div className={styles.orgName}>{u?.organization?.name}</div> -
                  <div className={styles.role}>{displayRole(u?.role?.title)} </div>
                </li>
              ))}
            </ul>
          )}

          <div className={styles.actionBtns}>
            <ContainedButton
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '32px' }}
              disabled={loading}
              kind="purple"
              onClick={submit}
            >
              <span ref={submitButtonRef}>Add as Super Admin</span>
            </ContainedButton>

            <OutlinedButton
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '32px' }}
              disabled={loading}
              kind="default"
              onClick={onClose}
            >
              <span>Cancel</span>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SetSuperAdminModal;
